module.exports = __webpack_public_path__ + "static/media/Sean_Spencer_Resume_ver2.9748b086.pdf";